import React from 'react';

const HeadingLarge = ({ children }) => {
    return (
        <div
            style={{
                fontFamily: 'Poppins',
                fontSize: '48px',
                fontWeight: 700,
                marginBottom: '20px',
                color: '${props=>props.theme.primaryFontColor}',
            }}
        >
            {children}
        </div>
    );
};

export default HeadingLarge;
